import { render } from "./ExaminePopup.vue?vue&type=template&id=dd815e58&scoped=true"
import script from "./ExaminePopup.vue?vue&type=script&lang=js"
export * from "./ExaminePopup.vue?vue&type=script&lang=js"

import "./ExaminePopup.vue?vue&type=style&index=0&id=dd815e58&lang=scss&scoped=true"

import exportComponent from "C:\\xiangmu\\gas-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd815e58"]])

export default __exports__